import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import { noWhiteStartOrEnd, numbersOnly } from '@ps/web-shared-validators';

import RMFSSNContainer from '../RMFSSNContainer/RMFSSNContainer';
import SSNTextInput from '../SSNTextInput/SSNTextInput';

import {
  TXTCLI_Please_enter_a_valid_SSN,
  TXTCLI_WhatXs_your_SSNX,
  TXTCLI_Your_SSN,
  TXTWCL_We_keep_your_data_safe
} from './RMFSSN9.messages.json';

const RMFSSN9: React.FC<{
  title?: TranslationTag;
  pageTopTitle?: TranslationTag;
  pageTopSubtitle?: React.ReactNode;
  showLockIcon?: boolean;
  page: React.ComponentType;
}> = ({
  title = TXTCLI_Your_SSN,
  pageTopTitle = TXTCLI_WhatXs_your_SSNX,
  pageTopSubtitle = <Translation {...TXTWCL_We_keep_your_data_safe} />,
  showLockIcon = false,
  page
}) => (
  <RMFSSNContainer
    page={page}
    title={title}
    pageTopTitle={pageTopTitle}
    pageTopSubtitle={pageTopSubtitle}
    showLockIcon={showLockIcon}
  >
    <SSNTextInput
      label=""
      id="nationalDocumentNumber"
      validators={[noWhiteStartOrEnd, numbersOnly(TXTCLI_Please_enter_a_valid_SSN)]}
    />
  </RMFSSNContainer>
);

export default RMFSSN9;
